<template>
  <section class="job-overview m-t-lg m-b-lg">
    <h2><i class="far fa-question-circle"></i> Load Requests</h2>

    <div class="ibox">
      <div class="ibox-content">
        <ul class="list-detail list-detail-load-request">
          <load-request-item
            v-for="load in loads"
            :key="load.id"
            :load="load">
          </load-request-item>

          <li class="text-center text-muted" v-if="haveNoLoadRequests">
            <strong>No load requests found.</strong>
          </li>
        </ul>
      </div>
      <div class="ibox-footer">
        <router-link :to="{ name: 'loads.requests' }">View All Load Requests</router-link>
      </div>
    </div>

    <load-request-modal></load-request-modal>
  </section>
</template>

<script>
  import { mapActions } from 'vuex'
  import { findIndex } from 'lodash'
  import LoadRequestItem from 'components/loads/LoadRequestItem'
  import LoadRequestModal from 'components/loads/LoadRequestModal'

  export default {
    components: {
      LoadRequestItem,
      LoadRequestModal
    },

    data () {
      return {
        loads: []
      }
    },

    computed: {
      haveNoLoadRequests () {
        return this.loads.length === 0
      }
    },

    created () {
      this.getLoads({ carrier_id: this.$user.id, requests: true, status: 'all', commodity: 'all', page_size: 3 })
        .then((response) => {
          this.loads = response.data.data
        })

      this.$bus.$on('loadRequestAcceptedOrDeclined', this.removeLoadRequestFromList)
    },

    beforeDestroy () {
      this.$bus.$off('loadRequestAcceptedOrDeclined', this.removeLoadRequestFromList)
    },

    methods: {
      ...mapActions('load', ['getLoads']),

      removeLoadRequestFromList (load) {
        this.loads.splice(findIndex(this.loads, existing => existing.id === load.id), 1)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LoadRequestList.vue?716b5d08